import { render } from "./v2_idx.vue?vue&type=template&id=f552f22a"
import script from "./v2_idx.vue?vue&type=script&lang=js"
export * from "./v2_idx.vue?vue&type=script&lang=js"

import "./v2_idx.vue?vue&type=style&index=0&id=f552f22a&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__